import { useEffect, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import ExportedImage from 'next-image-export-optimizer';
import Link from 'next/link';

import { motion } from 'framer-motion';
import kwesforms from 'kwesforms';

import { siteData } from '@/data/configs/site';
import contactHero from '@/public/images/lp/contact/contactHero.png';
import DiscordIcon from '@/public/images/lp/icons/social/Discord_Icon.svg';
// import EmailIcon from '@/public/images/lp/icons/social/Email_Icon.svg';
import GithubIcon from '@/public/images/lp/icons/social/Github_Icon.svg';
import RedditIcon from '@/public/images/lp/icons/social/Reddit_Icon.svg';
import TelegramIcon from '@/public/images/lp/icons/social/Telegram_Icon.svg';
import TwitterIcon from '@/public/images/lp/icons/social/Twitter_Icon.svg';
import YoutubeIcon from '@/public/images/lp/icons/social/Youtube_Icon.svg';

export default function Contact() {
  const [email, setEmail] = useState('');
  const [topic, setTopic] = useState('');
  const [message, setMessage] = useState('');

  const socialLinks = [
    // {
    //   href: `mailto:${siteData.defaultEmail}`,
    //   src: EmailIcon,
    //   width: 32,
    //   height: 33,
    //   alt: 'Email_Icon',
    // },
    {
      href: siteData.social.discord,
      src: DiscordIcon,
      width: 29,
      height: 29,
      alt: 'Discord_Icon',
    },
    {
      href: siteData.social.twitter,
      src: TwitterIcon,
      width: 29,
      height: 29,
      alt: 'Twitter_Icon',
    },
    {
      href: siteData.social.reddit,
      src: RedditIcon,
      width: 29,
      height: 29,
      alt: 'Reddit_Icon',
    },
    {
      href: siteData.social.telegram,
      src: TelegramIcon,
      width: 29,
      height: 29,
      alt: 'Telegram_Icon',
    },
    {
      href: siteData.social.youtube,
      src: YoutubeIcon,
      width: 29,
      height: 29,
      alt: 'Youtube_Icon',
    },
    {
      href: siteData.social.github,
      src: GithubIcon,
      width: 29,
      height: 29,
      alt: 'Github_Icon',
    },
  ];

  useEffect(() => {
    kwesforms.init();
  }, []);

  const fadeInUp = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 },
  };

  const staggerChildren = {
    animate: {
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  return (
    <>
      <ExportedImage
        src={contactHero}
        alt='contactHero'
        className='absolute bottom-0 right-0 z-[-10] h-auto w-full opacity-10 lg:hidden'
      />

      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
        className='container relative z-[100] mx-auto px-4 pt-[90px] font-sans text-white xs:px-8 lg:grid lg:h-screen lg:min-h-[900px] lg:grid-cols-24 lg:gap-0 lg:pt-[100px] xl:px-0 2xl:min-h-[996px]'
      >
        <div className='hidden xl:col-span-2 xl:block'></div>
        <div className='relative hidden w-full flex-col justify-center bg-brand-dark md:col-span-24 md:mx-auto lg:flex lg:flex-row lg:justify-center lg:gap-0 xl:col-span-20 xl:max-w-7xl 2xl:max-w-[1580px]'>
          <motion.section
            variants={fadeInUp}
            initial='initial'
            animate='animate'
            className='flex flex-col items-end justify-end gap-10 lg:w-1/2'
          >
            <motion.h1
              variants={fadeInUp}
              className='absolute left-0 top-0 font-heading font-semibold leading-[129%] text-white lg:text-[60px] xl:text-[70px]'
            >
              Got questions? <br /> Let&apos;s chat!
            </motion.h1>
            <ExportedImage src={contactHero} alt='contactHero' className='h-auto w-1/2 lg:w-full' />
          </motion.section>
          <motion.section
            variants={staggerChildren}
            initial='initial'
            animate='animate'
            className='flex flex-col lg:w-1/2 lg:pl-8'
          >
            <motion.span
              variants={fadeInUp}
              className='p-2 font-heading text-4xl font-semibold leading-[48px] text-white'
            >
              Contact Us
            </motion.span>
            <motion.div variants={fadeInUp} className='hero-contact overflow-hidden p-5 py-5'>
              <form
                action='https://kwes.io/api/foreign/forms/FjzAcC7ZHTCxNjF1LfTY'
                className='kwes-form contact-form space-y-5'
                has-recaptcha-v2='true'
                no-reload='true'
              >
                <motion.fieldset variants={fadeInUp}>
                  <div className='relative w-full rounded-[8px] bg-gradient-to-r from-[#FFFFFF] to-[#B8B0FF] p-[1px]'>
                    <input
                      type='email'
                      name='EMAIL'
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className='block w-full rounded-[7px] bg-[#0A1922] px-5 py-3 text-lg font-normal leading-7 text-light-white transition-all duration-300 focus:outline-none disabled:bg-[#f1f4f8]'
                      placeholder='Email (required)'
                      rules='required|email|max:255'
                    />
                  </div>
                </motion.fieldset>

                <motion.fieldset variants={fadeInUp} className='form-group'>
                  <div className='relative w-full rounded-[8px] bg-gradient-to-r from-[#FFFFFF] to-[#B8B0FF] p-[1px] -2xs:max-w-[238px]'>
                    <select
                      name='Topic'
                      value={topic}
                      onChange={(e) => setTopic(e.target.value)}
                      className='w-full rounded-[7px] bg-[#0A1922] px-5 py-3.5 text-light-white shadow-inner transition-all duration-300'
                      rules='required'
                    >
                      <option placeholder='true' value=''>
                        Choose a Topic (required)
                      </option>
                      <option value='Komodo Wallet Integration'>Komodo Wallet Integration</option>
                      <option value='Blockchain 51% Security'>Blockchain 51% Security</option>
                      <option value='Blockchain Creation'>Blockchain Creation</option>
                      <option value='Grants'>Grants</option>
                      <option value='Partnerships'>Partnerships</option>
                      <option value='Request an Interview'>Request an Interview</option>
                      <option value='Support Request'>Support Request</option>
                      <option value='Other'>Other</option>
                    </select>
                  </div>
                </motion.fieldset>

                <motion.fieldset variants={fadeInUp} className='form-group'>
                  <div className='relative w-full rounded-[8px] bg-gradient-to-r from-[#FFFFFF] to-[#B8B0FF] p-[1px]'>
                    <textarea
                      name='Text'
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      className='required form-control min-h-[108px] w-full resize-none rounded-[7px] bg-[#0A1922] px-5 py-3.5 leading-7 text-light-white shadow-inner transition-all duration-300'
                      placeholder='Your message (required)'
                      rules='required'
                    ></textarea>
                  </div>
                </motion.fieldset>

                <motion.fieldset variants={fadeInUp} className='clear text-right'>
                  <ReCAPTCHA sitekey='6LcMeu0iAAAAAPSzR-vtTQkxULQXQZ5yUqA-VtwP' className='mb-4' />
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    type='submit'
                    className='flex h-[44px] min-w-[117px] items-center justify-center rounded-[5px] bg-gradient-to-tr from-[#B8B0FF] to-[#FFFFFF] px-7 py-2 text-base font-bold text-black transition-all duration-300'
                  >
                    Submit
                  </motion.button>
                </motion.fieldset>
              </form>
            </motion.div>
            <motion.div variants={fadeInUp} className='space-y-1 px-5 pt-4'>
              <h5 className='contact-text text-lg'>Email:</h5>
              <p className='text-[1.3125rem] text-white'>{siteData.defaultEmail}</p>
            </motion.div>
            <motion.div variants={fadeInUp} className='space-y-1 px-5 pt-4'>
              <h5 className='contact-text text-lg text-white'>Follow Us:</h5>
              <motion.ul
                variants={staggerChildren}
                initial='initial'
                animate='animate'
                className='flex'
              >
                {socialLinks.map((link, index) => (
                  <motion.li key={index} whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.9 }}>
                    <Link href={link.href} target='_blank' rel='noopener noreferrer'>
                      <ExportedImage placeholder='empty' src={link.src} alt={link.alt} />
                    </Link>
                  </motion.li>
                ))}
              </motion.ul>
            </motion.div>
            <p className='mt-auto flex flex-row items-center justify-center self-start px-5 py-4 text-center font-heading text-base font-normal text-white'>
              © 2016 - {new Date().getFullYear()} by&nbsp;
              <Link href='https://komodoplatform.com/en/' className='font-semibold underline'>
                {' '}
                Komodo Platform
              </Link>
            </p>
          </motion.section>
        </div>
        <div className='relative mx-auto flex flex-col lg:hidden'>
          <div className=''>
            <h2 className='mx-auto px-5 text-start font-heading text-[35px] font-semibold leading-[129%] text-white xms:text-[45px] xs:text-[45px] sm:text-[50px]'>
              Got questions? <br />
              Let&apos;s chat!
            </h2>
          </div>
          <section className='flex w-[350px] flex-col xms:w-[400px] sm:w-[500px] lg:w-[681px]'>
            <span className='px-5 pb-5 font-heading text-4xl font-semibold leading-[48px] text-white -lg:hidden'>
              Contact Us
            </span>
            <div className='hero-contact overflow-hidden p-5 py-5'>
              <form
                action='https://kwes.io/api/foreign/forms/FjzAcC7ZHTCxNjF1LfTY'
                className='kwes-form contact-form space-y-4'
                has-recaptcha-v2='true'
                no-reload='true'
              >
                <fieldset>
                  <div className='relative w-full rounded-[8px] bg-gradient-to-r from-[#FFFFFF] to-[#B8B0FF] p-[1px]'>
                    <input
                      type='email'
                      name='EMAIL'
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className='block w-full rounded-[7px] bg-[#0A1922] px-5 py-3 text-lg font-normal leading-7 text-light-white focus:outline-none disabled:bg-[#f1f4f8]'
                      placeholder='Email (required)'
                      rules='required|email|max:255'
                    />
                  </div>
                </fieldset>

                <fieldset className='form-group'>
                  <div className='relative w-full rounded-[8px] bg-gradient-to-r from-[#FFFFFF] to-[#B8B0FF] p-[1px] -2xs:max-w-[238px]'>
                    <select
                      name='Topic'
                      value={topic}
                      onChange={(e) => setTopic(e.target.value)}
                      className='w-full rounded-[7px] bg-[#0A1922] px-5 py-3.5 text-light-white shadow-inner transition-all duration-300'
                      rules='required'
                    >
                      <option placeholder='true' value=''>
                        Choose a Topic (required)
                      </option>
                      <option value='Komodo Wallet Integration'>Komodo Wallet Integration</option>
                      <option value='Blockchain 51% Security'>Blockchain 51% Security</option>
                      <option value='Blockchain Creation'>Blockchain Creation</option>
                      <option value='Grants'>Grants</option>
                      <option value='Partnerships'>Partnerships</option>
                      <option value='Request an Interview'>Request an Interview</option>
                      <option value='Support Request'>Support Request</option>
                      <option value='Other'>Other</option>
                    </select>
                  </div>
                  <span className='form-control-line'></span>
                </fieldset>

                <fieldset className='form-group'>
                  <div className='relative w-full rounded-[8px] bg-gradient-to-r from-[#FFFFFF] to-[#B8B0FF] p-[1px]'>
                    <textarea
                      name='Text'
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      className='required form-control min-h-[170px] w-full rounded-[7px] bg-[#0A1922] px-5 py-3.5 leading-7 text-light-white shadow-inner transition-all duration-300'
                      rows={6}
                      placeholder='Your message (required)'
                      rules='required'
                    ></textarea>
                  </div>
                  <span className='form-control-line'></span>
                </fieldset>

                <fieldset className='clear text-right'>
                  <ReCAPTCHA sitekey='6LcMeu0iAAAAAPSzR-vtTQkxULQXQZ5yUqA-VtwP' className='mb-4' />
                  <button
                    type='submit'
                    className='flex h-[44px] min-w-[117px] items-center justify-center rounded-[5px] bg-gradient-to-tr from-[#B8B0FF] to-[#FFFFFF] text-base text-black'
                  >
                    Submit
                  </button>
                </fieldset>
              </form>
            </div>

            <div className='space-y-1 px-5 pb-2'>
              <h5 className='contact-text text-lg'>Email:</h5>
              <p className='text-[1.3125rem] text-white'>{siteData.defaultEmail}</p>
            </div>
            <div className='space-y-1 px-5'>
              <h5 className='contact-text text-lg text-white'>Follow Us:</h5>
              <ul className='flex 2xl:gap-4'>
                {socialLinks.map((link, index) => (
                  <li key={index}>
                    <Link href={link.href} target='_blank' rel='noopener noreferrer'>
                      <ExportedImage placeholder='empty' src={link.src} alt={link.alt} />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <p className='mx-auto mt-auto flex flex-row items-center justify-center py-4 text-center font-heading text-base font-normal text-white'>
              © 2016 - {new Date().getFullYear()} by&nbsp;
              <Link href='https://komodoplatform.com/en/' className='font-semibold underline'>
                Komodo Platform
              </Link>
            </p>
          </section>
        </div>
        <div className='hidden xl:col-span-2 xl:block'></div>
      </motion.main>
    </>
  );
}
